<template>
	<div class="heading-image">
		<slot>
			<hero-image :item="headingImage" />
		</slot>
	</div>
</template>

<script setup>
defineProps({
	headingImage: {
		type: Object,
		default: () => {},
	},
});
</script>

<style lang="scss" scoped>
.heading-image {
	position: relative;
}
</style>
